import { usePricingModulesState } from '../../../context/contexts/PricingModuleContext';
import { isAnyEnablingModulesActive } from '../../SystemSettings/hooks/lockedFeatures/utils';
import { RequiredModuleState } from '../../SystemSettings/hooks/lockedFeatures/types';

export const useEnableDisplayUserManagement = () => {
    const { pricingModulesState } = usePricingModulesState();

    return (
        !!pricingModulesState &&
        isAnyEnablingModulesActive(
            {
                mfaUsers: RequiredModuleState.ON_PREM_ENABLED,
                privilegedAccessSecurity: RequiredModuleState.ON_PREM_ENABLED
            },
            pricingModulesState
        )
    );
};
